export default "__VITE_ASSET__Z4j9npEx__"